module.exports = __webpack_public_path__ + "Allen-Digital-AppleStore.png";